<template>
    <div class="mainbox" style="border-radius:0 0 5px 5px">
        <div
            data-aos="fade-left"
            data-aos-delay="200"
            data-aos-easing="ease-in-out"
            data-aos-anchor-placement="top-bottom"
            data-aos-offset="120"
        >
            <h2 class="tit">{{lang[local].part4_txt1}}</h2>
            <p class="subtit">{{lang[local].part4_txt6}}</p>
            <ul class="list">
                <li>{{lang[local].part4_txt2}}</li>
                <li>{{lang[local].part4_txt3}}</li>
                <li>{{lang[local].part4_txt4}}</li>
                <li>{{lang[local].part4_txt5}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"
export default {
    data () {
        return{
            
        }
    },
    computed:
        mapState(['lang','local','skin'])
    ,
    mounted () {

    },
    methods:{

    }
    // render (h) {
    //     return (
    //     )
    // }
}
</script>

<style lang="less" scoped>
    .list{
        margin:40px auto;        
        overflow: hidden;
        font-size:15px;
        padding-left:3%;
        li{
            float: left;
            width:19%;
            margin:20px 3% 3% 3%;
            line-height:30px;
            white-space:pre-wrap;
            color: #8f8f8f;
            word-wrap:break-word; 
            // word-break:break-all;
        }
    }
</style>

